import React from "react";
import { Alert } from "react-bootstrap";
import { useAlert } from "../context/AlertMessageContext";

const Alerts = ({ variant, onClose, duration = 3500 }) => {
  const { message, setMessage } = useAlert();

  const handleClose = React.useCallback(() => {
    if (onClose) onClose();
    if (setMessage) setMessage("");
  }, [onClose, setMessage]);

  React.useEffect(() => {
    if (!message || !message.trim()) return;
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, handleClose]);

  if (!message || !message.trim()) {
    return null;
  }

  const isMultiLine = typeof message === "string" && message.includes("\n");

  return (
    <div
      style={{
        position: "fixed",
        top: "24px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000000,
        maxWidth: "600px",
        width: "max-content",
        minWidth: "260px",
        padding: "0 16px",
        boxSizing: "border-box",
        animation: "fadeInDown 0.3s ease-in-out",
      }}
    >
      <Alert
        variant={variant || "danger"}
        dismissible
        onClose={handleClose}
        style={{
          margin: 0,
          padding: "12px 18px",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.18), 0 8px 10px -6px rgba(0, 0, 0, 0.08)",
          borderRadius: "10px",
          fontSize: "0.95rem",
          fontWeight: "500",
          borderWidth: "1px",
          display: "flex",
          alignItems: isMultiLine ? "flex-start" : "center",
          gap: "12px",
          wordBreak: "break-word",
        }}
      >
        <div
          style={{
            flex: 1,
            paddingRight: "8px",
            textAlign: isMultiLine ? "left" : "center",
            lineHeight: "1.45",
          }}
        >
          {isMultiLine ? (
            message.split("\n").map((line, idx) => (
              <div
                key={idx}
                style={{
                  marginTop: idx > 0 ? "4px" : "0px",
                  fontWeight: idx === 0 ? "600" : "400",
                  fontSize: idx === 0 ? "0.98rem" : "0.90rem",
                }}
              >
                {line}
              </div>
            ))
          ) : (
            message
          )}
        </div>
      </Alert>
    </div>
  );
};

export default Alerts;

